(function () {
    'use strict';

    var app = angular.module('app', [
        // Angular modules 
        'ngAnimate',        // animations
        'ngRoute',          // routing
        'ngSanitize',       // sanitizes html bindings (ex: sidebar.js)
        'ngMessages',       // Validation Messages
        'ngFileUpload',			// Upload di Files
        'angularFileUpload', // Upload di Files https://github.com/nervgh/angular-file-upload/wiki/Module-API
        'angularMoment',        // work with date
        'angular.filter',				//angular-filter https://github.com/a8m/angular-filter
        //'angular-img-cropper',	//Image Cropper (angular-img-cropper.js)
        //'ngImgCrop',					//Image Cropper
        'imageCropper',				//Image Cropper (angular-image-cropper.js)
        'textAngular',              //TextAngular
        'signature',                //Signature
        'ngSignaturePad',
        // Custom modules 
        'common',           // common functions, logger, spinner
        'common.bootstrap', // bootstrap dialog wrapper functions
        // 3rd Party Modules
        'ui.bootstrap',      // ui-bootstrap (ex: carousel, pagination, dialog)
        'ui.sortable',			//sort item
        //'dialogs',					//finestre di Dialogo (dialogs.min.js)
        'infinite-scroll',    // infinite scroll
        'googlechart',      //gauge di tipo 'tachimetro'
        'checklist-model', //Multiselect checkbox
        'mwl.calendar' // angular-bootstrap-calendar, sito https://github.com/mattlewis92/angular-bootstrap-calendar
    ]);

    app.constant('_', _);     // Lodash library

    // Handle routing errors and success events
    app.run(['$route', '$location', '$rootScope', '$sce', 'datacontext', 'amMoment', '$window', function ($route, $location, $rootScope, $sce, datacontext, amMoment, $window) {
        // Include $route to kick start the router.

        angular.element($window).on('beforeunload', function (event) {
            // Qui puoi eseguire logica prima che la pagina venga ricaricata o chiusa
            // Attenzione: deve essere sincrono, non puoi fare chiamate $http
            console.log("Pagina in refresh o chiusura...");

            // Se vuoi mostrare un messaggio di conferma
            var message = "Sei sicuro di voler uscire?";
            (event || $window.event).returnValue = message;
            return message;
        });

        angular.element($window).on('keydown', function (event) {
            if (event.keyCode === 116) { // F5
                //event.preventDefault(); // blocca il refresh automatico
                console.log("Pagina in refresh o chiusura...");

                // Se vuoi mostrare un messaggio di conferma
                var message = "Sei sicuro di voler uscire?";
                (event || $window.event).returnValue = message;
                return message;
            }
        });

        $rootScope.filterKeydown = function (event, vm) {
            if (event.keyCode == 13) vm.cerca();
        };

        $rootScope.trustAsHtml = function (string) {
            return $sce.trustAsHtml(string);
        };        

        $rootScope.isIE = function () {
            var ua = window.navigator.userAgent;
            var trident = ua.indexOf("Trident");
            var msie = ua.indexOf("MSIE ");
            if (msie > 0 || trident > 0)
                return true;
            else
                return false;
        };

        $rootScope.detectIE = function () {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // IE 12 => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            // other browser
            return false;
        };

        $rootScope.detectIOS = function () {
            var isMacLike = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false;

            return isMacLike;
        };

        $rootScope.exportAll = function (sTableName, sType, sEscape, sFontSize) {
            var ua = window.navigator.userAgent;
            var trident = ua.indexOf("Trident");
            var msie = ua.indexOf("MSIE ");

            if (msie > 0 || trident > 0) {
                var table = $(sTableName);
                var strCopy = $('<div></div>').html(table.clone()).html(); window.clipboardData.setData("Text", strCopy);

                var objExcel = new ActiveXObject("Excel.Application");
                objExcel.visible = false;
                var objWorkbook = objExcel.Workbooks.Add;
                var objWorksheet = objWorkbook.Worksheets(1);
                objWorksheet.Paste;
                objExcel.visible = true;

            }
            else {
                if (sType == 'pdf')
                    $(sTableName).tableExport({ type: sType, pdfFontSize: sFontSize, escape: sEscape });
                else
                    $(sTableName).tableExport({ type: sType, escape: sEscape });
            }
            amMoment.changeLocale('it');
        };

        $rootScope.exportDiv = function (sTableName, sType) {
            console.info('exportDiv: %s of %s', sTableName, sType);
            var ua = window.navigator.userAgent;            
            var trident = ua.indexOf("Trident");
            var msie = ua.indexOf("MSIE ");            
            var table = $(sTableName);

            if (msie > 0 || trident > 0) {
                //console.log('exportDiv: msie or trident');
                var strCopy = $('<div></div>').html(table.clone()).html();
                window.clipboardData.setData("Text", strCopy);
                console.info('setData', strCopy);
                var objExcel = new ActiveXObject("Excel.Application");
                objExcel.visible = false;
                var objWorkbook = objExcel.Workbooks.Add;
                var objWorksheet = objWorkbook.Worksheets(1);
                objWorksheet.Paste;
                objExcel.visible = true;
            }
            else {
                //console.log('exportDiv: other');
                if (sType == 'pdf')
                    table.divExport({ type: sType });
                else
                    table.divExport({ type: sType });
            }
        };

        $rootScope.getAuthorization = function (vm, objName) {
            //console.info('$rootScope.getAuthorization() -> objName', objName);            
            vm.addDisabled = true;
            return datacontext.authorization_get(objName)
                .then(function (data) {
                    //console.info('$rootScope.getAuthorization() -> data', data);
                    if (data) {
                        vm.authorization = data;
                        vm.addDisabled = !vm.authorization.bInsert;
                        vm.isSUPER = (vm.authorization.iTags & 131071) == 131071;
                        vm.isGEST = !vm.isSUPER && (vm.authorization.iTags & 2048) == 2048;
                        vm.isIstruttore = !vm.isSUPER && (vm.authorization.iTags & 1024) == 1024;
                        vm.isCIAPI = !vm.isSUPER && (vm.authorization.iTags & 32) == 32;
                        vm.isGUEST = !vm.isSUPER && (vm.authorization.iTags & 16) == 16;
                        vm.isUMC = !vm.isSUPER && (vm.authorization.iTags & 8) == 8;
                        vm.isFAM = !vm.isSUPER && (vm.authorization.iTags & 8) == 8;
                        vm.isCPI = !vm.isSUPER && (vm.authorization.iTags & 4) == 4;

                        vm.isGUESTFORM = !vm.isSUPER && (vm.authorization.iTags & 16) == 16;

                        vm.isSuperUSER = vm.isSUPER || vm.isCIAPI || vm.isGUEST || vm.isUMC || vm.isCPI || vm.isFAM;

                        vm.isSpecial = vm.isSUPER || vm.isCIAPI || vm.isUMC || vm.isFAM;

                        vm.showInfo = false;

                        if (vm.isSUPER)
                            vm.EnableToComplete = false;
                        else
                            vm.EnableToComplete = true; //20gg dalla presa in carico//moment($scope.regAttivita.Data,'DD/MM/YYYY').isSame(moment(), 'day');

                        vm.isAPL = !vm.isSUPER && (vm.authorization.iTags & 2) == 2;
                    }
                });
        };


        $rootScope.getRisorsa = function (vm) {
            return datacontext.risorsa_getByUsername().then(function (data) {
                if (data == null) {
                    vm.risorsa = {};
                }
                else {
                    vm.risorsa = data;
                }
                console.info('myRis', data);
                return vm.risorsa;
            });
        };

        $rootScope.showJSON = function (modal, _item, _source) {
            var modalInstance = modal.open({
                templateUrl: '/app/html-templates/Modal/showJSON.html?version=127',
                controller: 'showJSON',
                resolve: {
                    item: function () {
                        return _item;
                    },
                    source: function () {
                        return _source;
                    }
                }
            });

            modalInstance.result.then(function () {
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        $rootScope.getSoggetti = function(vm, tRuoloCode) {
            var iStato = 6; //Decretati
            return datacontext.azienda_getAllList('', '', 0, tRuoloCode, '', '', 0, 0, 0, '', '', '', iStato).then(function (data) {
                switch (tRuoloCode) {
                    case 'AZD_PROM-FAM1':
                        vm.cmblist.soggettiFAM = data;
                        break;
                    case 'AZD_PROM-LAV1':
                        vm.cmblist.soggettiLAV = data;
                        break;
                    case 'AZD_FORM-FAM1':
                        vm.cmblist.entiFAM = data;
                        break;
                    case 'AZD_FORM-LAV1':
                        vm.cmblist.entiLAV = data;
                        break;
                }
                return true;
            });
        };


    }]);


    app.service('sectionMenu', function () {
        var _section = '';
        var _enabledLEP = false;
        var _ableToWork = false;
        var _ableToAz1 = false;
        var _ableToAz2 = false;
        var _ableToAz3 = false;
        var _ableToAz4 = false;
        var _notificationCount = 0;
        var _notifications = [];
        var _aziendaId = 0;
        var _lnkPDFBando = '';
        var _lnkPDFManuale = '';
        var _lnkOfficialSite = '';
        var _lnkVideoGuida = '';
        var _urlLogoHeader = '';
        var _showInfoMsg = false;
        var _projectUID = '';
        var _tipoCandidatura = 0;
        var _labelCF = '';
        var _tRuoloCode = '';
        var _tMisuraCode = '';
        var _username = '';
        var _tMisure = [];

        var setSection = function (area) {
            //console.log('SERVICE: setSection');
            //console.log(area);
            return _section = area;
        };

        var getSection = function () {
            //console.log('SERVICE: getSection');
            //console.log(section);
            return _section;
        };

        var isSectionActive = function (area) {
            //console.log('SERVICE: isSectionActive');
            //console.log(section);
            return _section == area;
        };

        var getClassIfActive = function (area) {
            //console.log('SERVICE: isSectionActive');
            //console.log(section);
            return _section == area ? 'activated' : '';
        };

        var isAbleToWork = function () {
            //console.info('isAbleToWork', item);
            return _ableToWork;
        };

        var setAbleToWork = function (value) {
            return _ableToWork = value;
        };

        var isEnabledLEP = function () {
            //console.info('isAbleToWork', item);
            return _enabledLEP;
        };

        var setEnabledLEP = function (value) {
            return _enabledLEP = value;
        };

        //Abilita il menu in base alle azioni attivate
        var isAbleToAz1 = function () {
            return _ableToAz1;
        };

        var setAbleToAz1 = function (value) {
            return _ableToAz1 = value;
        };

        var isAbleToAz2 = function () {
            return _ableToAz2;
        };

        var setAbleToAz2 = function (value) {
            return _ableToAz2 = value;
        };

        var isAbleToAz3 = function () {
            return _ableToAz3;
        };

        var setAbleToAz3 = function (value) {
            return _ableToAz3 = value;
        };

        var isAbleToAz4 = function () {
            return _ableToAz4;
        };

        var setAbleToAz4 = function (value) {
            return _ableToAz4 = value;
        };

        var setUsername = function (username) {
            return _username = username;
        };

        var getUsername = function () {
            return _username;
        };



        var pushNotificationUser = function (datacontext, notificationId) {
            return datacontext.notificationUser_push(notificationId).then(function (data) {
                if (data == null) return;
                return setNotificationCount(datacontext).then(function (data) {
                    return setNotification(datacontext).then(function (data) {
                        return _notifications;
                    });
                });
            });
        };

        function setNotificationCount(datacontext) {
            return datacontext.notification_countAll('', true, 2, 0, -1, 2, 0, 0).then(function (data) {
                if (data == '500') data = 0;
                return _notificationCount = data;
            });
        }

        function setNotification(datacontext) {
            return datacontext.notification_getAll(0, 0, '', true, 2, 0, -1, 2, 0, 0, '').then(function (data) {
                if (data == '500') data = 0;
                return _notifications = data;
            });
        }

        function getNotificationCount() {
            return _notificationCount;
        }

        function getNotification() {
            return _notifications;
        }

        var getAziendaId = function () {
            return _aziendaId;
        };

        var setAziendaId = function (value) {
            return _aziendaId = value;
        };

        var getLnkPDFBando = function () {
            return _lnkPDFBando;
        };

        var setLnkPDFBando = function (value) {
            return _lnkPDFBando = value;
        };

        var getLnkPDFManuale = function () {
            return _lnkPDFManuale;
        };

        var setLnkPDFManuale = function (value) {
            return _lnkPDFManuale = value;
        };

        var getLnkOfficialSite = function () {
            return _lnkOfficialSite;
        };

        var setLnkOfficialSite = function (value) {
            return _lnkOfficialSite = value;
        };

        var getLnkVideoGuida = function () {
            return _lnkVideoGuida;
        };

        var setLnkVideoGuida = function (value) {
            return _lnkVideoGuida = value;
        };

        var getUrlLogoHeader = function () {
            return _urlLogoHeader;
        };

        var setUrlLogoHeader = function (value) {
            return _urlLogoHeader = value;
        };

        var getInfoMsg = function () {
            return _showInfoMsg;
        };

        var setInfoMsg = function (value) {
            return _showInfoMsg = value;
        };

        var getProjectUID = function () {
            return _projectUID;
        };

        var setProjectUID = function (value) {
            return _projectUID = value;
        };

        var getTipoCandidatura = function () {
            return _tipoCandidatura;
        };

        var setTipoCandidatura = function (value) {
            return _tipoCandidatura = value;
        };

        var getLabelCF = function () {
            return _labelCF;
        };
        var setLabelCF = function (value) {
            return _labelCF = value;
        };

        var getTRuoloCode = function () {
            return _tRuoloCode;
        };
        var setTRuoloCode = function (value) {
            return _tRuoloCode = value;
        };
        var getTMisuraCode = function () {
            return _tMisuraCode;
        };
        var setTMisuraCode = function (value) {
            return _tMisuraCode = value;
        };

        var getTMisure = function (_datacontext) {
            return _datacontext.tMisura_getAll().then(function (data) {
                //console.info('getTMisure()', data);
                return _tMisure = data;
            });
        };
        var getTMisureLoaded = function () {
            return _tMisure;
        };

        return {
            setSection: setSection,
            getSection: getSection,
            isSectionActive: isSectionActive,
            getClassIfActive: getClassIfActive,
            isEnabledLEP: isEnabledLEP,
            setEnabledLEP: setEnabledLEP,
            isAbleToWork: isAbleToWork,
            setAbleToWork: setAbleToWork,
            //abilito il menu in base alle azioni attivate
            isAbleToAz1: isAbleToAz1,
            setAbleToAz1: setAbleToAz1,
            isAbleToAz2: isAbleToAz2,
            setAbleToAz2: setAbleToAz2,
            isAbleToAz3: isAbleToAz3,
            setAbleToAz3: setAbleToAz3,
            isAbleToAz4: isAbleToAz4,
            setAbleToAz4: setAbleToAz4,

            setUsername: setUsername,
            getUsername: getUsername,

            //Notifiche
            pushNotificationUser: pushNotificationUser,
            setNotificationCount: setNotificationCount,
            setNotification: setNotification,
            getNotificationCount: getNotificationCount,
            getNotification: getNotification,
            //Recupera AziendaId da Risorsa
            getAziendaId: getAziendaId,
            setAziendaId: setAziendaId,
            //Link PDF Bando
            getLnkPDFBando: getLnkPDFBando,
            setLnkPDFBando: setLnkPDFBando,
            //Link PDF Manuale
            getLnkPDFManuale: getLnkPDFManuale,
            setLnkPDFManuale: setLnkPDFManuale,
            //Link SIto Ufficiale
            getLnkOfficialSite: getLnkOfficialSite,
            setLnkOfficialSite: setLnkOfficialSite,
            //Link Video Guida
            getLnkVideoGuida: getLnkVideoGuida,
            setLnkVideoGuida: setLnkVideoGuida,
            //Url Logo Header
            getUrlLogoHeader: getUrlLogoHeader,
            setUrlLogoHeader: setUrlLogoHeader,
            //Show Info Message
            getInfoMsg: getInfoMsg,
            setInfoMsg: setInfoMsg,
            //Route ProjectID
            getProjectUID: getProjectUID,
            setProjectUID: setProjectUID,
            //Route TipoCandidatura
            getTipoCandidatura: getTipoCandidatura,
            setTipoCandidatura: setTipoCandidatura,
            //Label CF / PIVA invio email
            getLabelCF: getLabelCF,
            setLabelCF: setLabelCF,
            //TRuoloCode
            getTRuoloCode: getTRuoloCode,
            setTRuoloCode: setTRuoloCode,
            //TMisuraCode per Super
            getTMisuraCode: getTMisuraCode,
            setTMisuraCode: setTMisuraCode,
            //TMisure array
            getTMisure: getTMisure,
            getTMisureLoaded: getTMisureLoaded

        };
    });
})();
